import { render } from "./page404.vue?vue&type=template&id=55d6cb67"
import script from "./page404.vue?vue&type=script&lang=js"
export * from "./page404.vue?vue&type=script&lang=js"

import "./page404.vue?vue&type=style&index=0&id=55d6cb67&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__